module.exports = __webpack_public_path__ + "img/icon_innerLinkTeacher.3978a384.svg";